import { render, staticRenderFns } from "./TermsOfServiceEN.vue?vue&type=template&id=45746208&scoped=true&"
var script = {}
import style0 from "./TermsOfServiceEN.vue?vue&type=style&index=0&id=45746208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45746208",
  null
  
)

export default component.exports